// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"442ea837","794":"6e2bc833"}[chunkId] + ".chunk.js";
};